module.exports = __webpack_public_path__ + "img/calcaneare_dx.e643b865.png";